import React from "react";
import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";

export const Sparkline = ({ data = [], up = true, height = 32 }) => {
  const chartData = data.map((v, i) => ({ i, v }));
  const color = up ? "#00C805" : "#FF3B30";
  if (!data.length) return <div style={{ height }} />;
  const min = Math.min(...data);
  const max = Math.max(...data);
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={chartData} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
        <YAxis domain={[min, max]} hide />
        <Line type="monotone" dataKey="v" stroke={color} strokeWidth={1.5} dot={false} isAnimationActive={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};
